<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DawYjH/tc-custom/9781504041669.jpg?1704316981296" alt="This image is the cover for the book Birds, Beasts and Relatives, The Corfu Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Birds, Beasts and Relatives, The Corfu Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>The follow-up to <i>My Family and Other Animals </i>and the inspiration for <i>The Durrells in Corfu</i>: A naturalist’s memoir of his family’s time on a Greek island.</b><br/><br/> In the years before World War II, Gerald Durrell’s family left the gloomy shores of England for the sun-drenched island of Corfu. Against this picturesque backdrop, Durrell fondly recalls his family’s disorderly household and outrageous antics, including their interactions with locals of both human and animal varieties.<br/>  <br/> After a boyhood spent studying zoology and acquiring the island’s exotic insects, reptiles, birds, mammals, and sea creatures as pets, Durrell’s budding naturalism would later bloom into a passion for conservation that would last a lifetime.<br/>  <br/> Filled with clever observations, amusing anecdotes, and childlike wonder, <i>Birds, Beasts and Relatives</i> is half nature guide, half coming-of-age tale, and all charmingly funny memoir.<br/>  <br/><i>This ebook features an illustrated biography of Gerald Durrell including rare photos from the author’s estate.</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gerald Durrell
      </h2>
      
      <p class="authorDescription body article">&amp;lt;p&amp;gt;&amp;lt;b&amp;gt;Gerald Durrell&amp;lt;/b&amp;gt; was a naturalist and author of memoirs based on his life with &#8212;              and love for &#8212;              animals. He founded the Durrell Wildlife Conservation Trust and the Durrell Wildlife Park on the isle of Jersey.&amp;lt;/p&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d85240a